import React, { useState } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
} from "@mui/material";
import { Edit, Trash, ExternalLink } from "lucide-react";
import { toast } from "react-hot-toast";

const MyTable = ({ records }) => {
  const [formData, setFormData] = useState({
    toolName: "",
    driveLink: "",
    description: "",
  });
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const role = sessionStorage.getItem("role");
  const token = sessionStorage.getItem("accesstoken");

  const handleEditClick = (record) => {
    setFormData(record);
    setCurrentRecord(record);
    setOpenEditDialog(true);
  };

  const handleDeleteClick = (record) => {
    setCurrentRecord(record);
    setOpenDeleteDialog(true);
  };

  const handleSaveEdit = async () => {
    const response = await fetch(
      `https://rohan-tax-services.onrender.com/api/auth/edittool`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          toolid: formData._id,
          newtoolname: formData.name,
          description: formData.description,
          link: formData.link,
          role: role,
        }),
      }
    );

    if (response.ok) {
      toast.success("Tool updated successfully");
      window.location.reload();
    } else {
      toast.error("Error updating tool");
    }
    setOpenEditDialog(false);
  };

  const handleConfirmDelete = async () => {
    const response = await fetch(
      `https://rohan-tax-services.onrender.com/api/auth/deletetool`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          toolid: currentRecord._id,
          role: role,
        }),
      }
    );

    if (response.ok) {
      toast.success("Tool deleted successfully");
      setCurrentRecord(null);
      window.location.reload();
    } else {
      toast.error("Error deleting tool");
    }

    setOpenDeleteDialog(false);
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Tool Name",
      size: 200,
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 200,
      Cell: ({ cell }) => {
        const description = cell.getValue();
        const words = description.split(" ");
        const shortDescription =
          words.length > 10
            ? `${words.slice(0, 10).join(" ")}...`
            : description;
        return <span>{shortDescription}</span>;
      },
    },
    {
      accessorKey: "downloads",
      header: "Downloads",
      size: 100,
    },
    {
      accessorKey: "link",
      header: "Drive Link",
      size: 100,
      Cell: ({ cell }) => (
        <IconButton
          component="a"
          href={cell.row.original.link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "green" }}
        >
          <ExternalLink />
        </IconButton>
      ),
    },
    {
      accessorKey: "Edit",
      header: "Edit",
      size: 100,
      Cell: ({ cell }) => (
        <IconButton
          style={{ color: "blue" }}
          onClick={() => handleEditClick(cell.row.original)}
        >
          <Edit />
        </IconButton>
      ),
    },
    {
      accessorKey: "Delete",
      header: "Delete",
      size: 100,
      Cell: ({ cell }) => (
        <IconButton
          style={{ color: "red" }}
          onClick={() => handleDeleteClick(cell.row.original)}
        >
          <Trash />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <div style={{ padding: "20px" }}>
        <MaterialReactTable columns={columns} data={records} />
      </div>

      {/* Edit Dialog */}
      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
        <DialogTitle>Edit Tool</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Tool Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Drive Link"
            multiline
            minRows={2}
            value={formData.link}
            onChange={(e) =>
              setFormData({ ...formData, driveLink: e.target.value })
            }
            margin="normal"
          />
          <TextField
            fullWidth
            label="Description"
            value={formData.description}
            multiline
            minRows={4}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button onClick={handleSaveEdit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this item?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MyTable;
